import { Button } from 'semantic-ui-react';
/* eslint react/jsx-props-no-spreading: 0 */
export default function LinkButton(props) {
  return <Button {...props} basic className="button-link" />;
}
/* eslint react/jsx-props-no-spreading: 0 */
